module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.9.0 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 事件 on-after-show on-after-hide #2465")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 weui-loading 样式")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 inputAttrs 无默认值导致的报错 #2618")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复输入框获取焦点后又失去焦点 #2610")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持使用 order-map 自定义列顺序 #2300")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复遮罩导致页面滚动 #2593")]), _vm._v(" "), _c('li', [_vm._v("[feature] 事件 on-confirm 添加当前值 #2632")]), _vm._v(" "), _c('li', [_vm._v("[fix] 在 nextTick 后触发 on-confirm 事件 #2632")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持格式 YYYY-MM-DD A 选择上下午 #2627 @jack87918")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-x-switch.html"
    }
  }, [_vm._v("InlineXSwitch")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 新组件 #2624")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/loading.html"
    }
  }, [_vm._v("Loading")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 添加变量 loading-z-index 避免与 toast-z-index 冲突 #2484")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 支持使用空字符隐藏提示文字 #2566")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/msg.html"
    }
  }, [_vm._v("Msg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] prop:buttons 数组作为 slot:buttons 默认内容")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/picker.html"
    }
  }, [_vm._v("Picker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 开发模式下 picker 数据非字符串时显示提示 #2568")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popover.html"
    }
  }, [_vm._v("Popover")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复在 fixed 容器里定位不正确 #2590")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持属性 disabled #2594")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 should-rerender-on-show 实现每次打开重新渲染 #2598")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持自动滚动到顶部 #2598")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加事件 on-clear #2251")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复新版本 vue 导致的 select 值问题 #2633 #2587")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 标题使用 v-html #2615")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/sticky.html"
    }
  }, [_vm._v("Sticky")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加属性 disabled #2601")]), _vm._v(" "), _c('li', [_vm._v("[enhance] scroll-box 不存在时在开发模式下进行提示")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tab.html"
    }
  }, [_vm._v("Tab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持使用 bar-position 定义边框位置")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加属性 disabled 支持禁用 #2641")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-button.html"
    }
  }, [_vm._v("XButton")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] warn 类型支持 plain 样式 #2478")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-circle.html"
    }
  }, [_vm._v("XCircle")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持渐变色 #2616 @spencer1994")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持样式变量 dialog-gap-width #2640")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 支持样式变量 dialog-width and dialog-max-width #2577")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复在空值时 valid 为 true 的问题 #2415")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复 disabled 样式在 iOS 下过浅的问题 #2458")]), _vm._v(" "), _c('li', [_vm._v("[change] 仅在获得焦点时显示清除按钮 #2567")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持事件 on-click-clear-icon #2603")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 获得焦点时滚动到可视区域(Android) #2604")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4e05dc8f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4e05dc8f"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.9.0-270.vue
// module id = 2232
// module chunks = 228